<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="Privacy Policy" src="/images/sub/sub-visual.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

         <page-section class="page-section--first page-section--last">
            <terms-component code="privacy" />
         </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TermsComponent from "@/components/client/terms/terms-component.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TermsComponent,
    },
    props: {
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
            });
        }
    },
};
</script>

<style lang="scss" scoped>
</style>